exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tr-whole-border th[data-v-28d5bb55]{padding:12px 6px}.many-field-tr td[data-v-28d5bb55]{padding:6px}.lp-form-type[data-v-28d5bb55]{color:#787878;display:table-cell;font-size:.8rem}.table-cell[data-v-28d5bb55]{text-align:left;width:100%}", ""]);

// exports
